exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/deep-equal/lib/keys.js
 ** module id = 829
 ** module chunks = 0
 **/